import React, { useEffect, useState } from 'react';
import { fetchCaseStudyImages, type CaseStudyImage } from './fetchCaseStudies';

function AppsAndSites() {
  const [images, setImages] = useState<CaseStudyImage[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;

    const loadImages = async () => {
      try {
        setLoading(true);
        setError(null);
        const caseStudies = await fetchCaseStudyImages();
        if (!cancelled) {
          setImages(caseStudies);
        }
      } catch (err) {
        console.error('Failed to load case study images:', err);
        if (!cancelled) {
          setError('Failed to load images. Please try again later.');
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    loadImages();

    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <section className="apps-and-sites" id="apps-and-sites">
      <h1>MOBILE & WEB PRODUCTS</h1>

      {loading && <p className="apps-and-sites-status">LOADING...</p>}
      {error && <p className="apps-and-sites-status apps-and-sites-error">{error}</p>}

      {!loading && !error && (
        <div className="apps-and-sites-grid">
          {images.map((item) => (
            <img
              key={item.fileName}
              src={item.image}
              alt={item.fileName.replace(/\.[^.]+$/, '').replace(/[-_]/g, ' ')}
              className="apps-and-sites-logo"
            />
          ))}
        </div>
      )}
    </section>
  );
}

export default AppsAndSites;
